import React from 'react';

interface Props {
  color?: string;
  fontSize?: number | string;
}

const ThumbsUp: React.FC<Props> = ({ color = 'inherit', fontSize = 'inherit' }) => {
  return (
    <svg
      role="img"
      width="1em"
      height="1em"
      style={{ fontSize: typeof fontSize === 'string' ? fontSize : `${fontSize}px`, color }}
      viewBox="0 0 18.429 18.698"
    >
      <defs></defs>

      <path
        id="thumbs-up"
        d="M12.319,8.019V4.58A2.58,2.58,0,0,0,9.739,2L6.3,9.739V19.2H16a1.72,1.72,0,0,0,1.72-1.462L18.906,10a1.72,1.72,0,0,0-1.72-1.978ZM6.3,19.2H3.72A1.72,1.72,0,0,1,2,17.478V11.459a1.72,1.72,0,0,1,1.72-1.72H6.3"
        transform="translate(-1.25 -1.25)"
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
      />
    </svg>
  );
};

export default ThumbsUp;
